import React, { useEffect, useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

import './index.css';

import WebcastingContext from '../context/webcasting/webcastingContext';

// Components
import SpinnerAbsolute from '../components/UI/SpinnerAbsolute';
import NotFound from '../components/UI/NotFound';
import MemoizedPreviewLayout from './MemoizedPreviewLayout';
import HeadStyle from './HeadStyle';

const Console = (props) => {
  console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>> passed data to log: ', props);
  return null;
};

///////// NOTES /////////
// Received props are React Route related such as: history, location, match
// Event from context is a single event object (res.data.data[0]), not { items: [...] }
const PreviewLayout = (props) => {
  const location = useLocation();
  const webcastingContext = useContext(WebcastingContext);
  const {
    loading,
    event,
    getEvent,
    readLocalData,
    localData,
    branding,
    validatePreviewAccess,
  } =
    webcastingContext;

  const eventId = props?.match?.match?.params?.eventId;
  const previewKey = new URLSearchParams(location.search).get('previewKey');
  const hasEventItem = event && (Array.isArray(event) ? event.length > 0 : true);
  const [previewAccessChecked, setPreviewAccessChecked] = useState(false);
  const [hasPreviewAccess, setHasPreviewAccess] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const runPreviewValidation = async () => {
      if (!eventId || !previewKey) {
        if (isMounted) {
          setHasPreviewAccess(false);
          setPreviewAccessChecked(true);
        }
        return;
      }

      const isValid = await validatePreviewAccess(eventId, previewKey);

      if (!isMounted) return;

      setHasPreviewAccess(isValid);
      setPreviewAccessChecked(true);

      if (isValid) {
        getEvent(eventId);
      }
    };

    setPreviewAccessChecked(false);
    runPreviewValidation();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, previewKey]);

  useEffect(() => {
    if (hasPreviewAccess && event && !Array.isArray(event)) readLocalData(event, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, hasPreviewAccess]);

  return (
    <>
      {!previewAccessChecked || (hasPreviewAccess && (loading || !hasEventItem)) ? (
        <SpinnerAbsolute />
      ) : !hasPreviewAccess ? (
        <NotFound msg="Invalid preview link." statusCode="403" />
      ) : event.success === false ? (
        <>
          <NotFound msg={event?.message?.message} />
          <Console msg={event} />
        </>
      ) : (
        <>
          {branding ? <HeadStyle branding={branding} /> : <HeadStyle />}
          <MemoizedPreviewLayout
            match={props.match}
            loading={loading}
            event={event}
            saveAuth={false}
            authorization={props.match.match.params.confirmationId}
            localData={localData}
            preview={true}
          />
        </>
      )}
    </>
  );
};

export default React.memo(PreviewLayout);
